<template>
    <div class="login">
        <ul class="login_lists">
            <li :class="{list_active:isPswShow}" @click="switchover(0)">{{$t('account')}}</li>
            <li :class="{list_active:isPswShow == false}" @click="switchover(1)">{{$t('without_code')}}</li>
        </ul>
        <form action="" id="account_login" v-if="isPswShow" :key="1">
            <div class="input input1">
                <input type="text" v-focus="focusState" :placeholder="$t('placeholder_code')" class="u_phone" name="username"
                       autocomplete="off" v-model="generalAccount" @blur="searchIos" @keypress="searchAndroid">
            </div>
            <div class="input input2">
                <input type="password" name="password" :placeholder="$t('placeholder_psd')" autocomplete="off"
                       v-model="generalPassWord" @blur="searchIos" @keypress="searchAndroid">
            </div>
            <div class="input_verity">
                <div class="input_verity_box verity_box">
                    <input type="text" :placeholder="$t('placeholder_img_verity')" name="verify_code" autocomplete="off"
                           v-model="user_verify_code" @blur="searchIos" @keypress="searchAndroid">
                </div>
                <div class="check_code_img" id="reg_verify_code">
                    <img :src="registerVerifyCodeImg" alt="" class="verify_code_img"
                         @click="getRegisterVerifyCodeImg()" @blur="searchIos" @keypress="searchAndroid">
                </div>
            </div>
            <div class="other_phone">
                <!--<span @click="forgetPsd()">忘记密码？</span>-->
            </div>
            <button type="button" id="account_login_btn" class="login_btn" @click="generalLoginFunc()">{{$t('login')}}</button>
              <a  class="register_btn"  @click="getRegister()">{{$t('register')}}</a>
             <!-- <p class="other_login">其他方式登录</p>
              <ul class="login_icons">
                  <li><img src="../../assets/images/personalCenter/weixin.png" alt=""></li>
                  <li><img src="../../assets/images/personalCenter/QQ.png" alt=""></li>
              </ul>-->
        </form>
        <form action="" id="avoid_close_login" v-else :key="2">
            <div class="input input1">
                <input type="text" name="username"  v-focus="focusState" :placeholder="$t('placeholder_code')" autocomplete="off"
                       v-model="otherAccount" @blur="searchIos" @keypress="searchAndroid">
            </div>
            <div class="input_verity">
                <div class="input_verity_box verity_box">
                    <input type="text" :placeholder="$t('placeholder_img_verity')" name="verify_code"  autocomplete="off"
                           v-model="user_verify_code2" @blur="searchIos" @keypress="searchAndroid">
                </div>
                <div class="check_code_img" id="verify_code">
                    <img :src="registerVerifyCodeImg2" alt="" class="verify_code_img"
                         @click="getRegisterVerifyCodeImg2()" @blur="searchIos" @keypress="searchAndroid">
                </div>
            </div>
            <div class="input_verity">
                <div class="input_verity_box mes_verity_box">
                    <input type="text" :placeholder="$t('placeholder_verity')"  autocomplete="off" name="mes_code"
                           id="mes_code" v-model="msgCheckCode" @blur="searchIos" @keypress="searchAndroid">
                </div>
                <span class="mes_count_down count_down" @click="getMsgCodeFunc()" v-if="isGetCodeShow">{{$t('get_verity')}}</span>
                <span class="mes_count_down count_down" v-else>{{waitingTime}}(s)</span>
            </div>

            <button type="button" id="avoid_close_login_btn" class="login_btn" @click="otherLoginFunc()">{{$t('login')}}</button>
             <a class="register_btn" @click="getRegister()">{{$t('register')}}</a>
            <!-- <p class="other_login">其他方式登录</p>
             <ul class="login_icons">
                 <li><img src="../../assets/images/personalCenter/weixin.png" alt=""></li>
                 <li><img src="../../assets/images/personalCenter/QQ.png" alt=""></li>
             </ul>-->
        </form>


    </div>
</template>

<script>
import { Toast } from "mint-ui";

export default {
  name: "login",
  data: function() {
    return {
      isPswShow: true, //默认为true，显示“账号登陆”
      generalAccount: "", //普通登陆的账号
      generalPassWord: "", //普通登陆的密码
      regTel: /^1[345789]\d{9}$/, //验证手机号的正则表达式
      user_verify_code: "", //图片验证码
      registerVerifyCodeImg: "", //登陆的图形验证码(图片)
      user_verify_code2: "", //(免密登陆)图片验证码
      registerVerifyCodeImg2: "", //(免密登陆)登陆的图形验证码(图片)
      otherAccount: "", //免密登陆的账号
      isGetCodeShow: true, //默认为true，显示“获取验证码”按钮
      waitingTime: 120, //获取短信验证所需要等待的时间，默认是120(s)，单位是s
      msgCheckCode: "", //短信验证码
      focusState: true
      // userInformationObj:{},
    };
  },
  directives: {
    focus: {
      inserted(el, { value }) {
        //inserted只有第一次聚焦
        //页面渲染时，第一个input框聚焦，
        // console.log(el, {value});
        if (value) {
          el.focus();
        }
      }
    }
  },

  created: function() {
    this.getRegisterVerifyCodeImg();
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "login");
  },
  watch: {
    waitingTime: function(n, o) {
      if (n <= 0) {
        clearInterval(this.stopWaiting);
        this.waitingTime = 120;
        this.isGetCodeShow = true;
      }
    }
  },
  methods: {
    switchover: function(id) {
      this.focusState = true;
      if (id) {
        this.isPswShow = false;
        this.getRegisterVerifyCodeImg2();
      } else {
        this.isPswShow = true;
      }
    },

    // 普通登陆按钮的方法
    generalLoginFunc: function() {
      if (!this.generalAccount) {
        // Toast("账号不能为空");
        this.showMsg("账号不能为空");
        this.getRegisterVerifyCodeImg();
        return false;
      }
      if (!this.regTel.test(this.generalAccount)) {
        this.showMsg("手机号格式不正确");
        this.getRegisterVerifyCodeImg();
        return false;
      }
      if (!this.generalPassWord) {
        this.showMsg("密码不能为空");
        this.getRegisterVerifyCodeImg();
        return false;
      }

      // 发送登陆数据
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/User/do_login",
        dataType: "json",
        data: {
          username: this.generalAccount,
          password: this.generalPassWord,
          verify_code: this.user_verify_code
        }
      })
        .then(res => {
          if (res.data.status == 1) {
            this.showMsg(res.data.msg);
            this.loginSuccess(res.data.result);
          } else {
            this.showMsg(res.data.msg);
            this.getRegisterVerifyCodeImg();
          }
        })
        .catch(err => {
          this.showMsg("网络错误，请稍后再试");
          console.log(err);
        });
    },
    searchIos() {
      //ios点击完成失去焦点搜索
      /* this.search();*/
      this.inputBlur();
    },
    searchAndroid(event) {
      //android点击搜索，未能失去焦点，故失去焦点事件无法触发，单可以调用键盘事件处理
      if (event.keyCode == 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        /* this.search();*/
        this.inputBlur();
      }
    },
    // 获取注册页面的图形验证码的方法
    getRegisterVerifyCodeImg: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/User/verify",
        dataType: "json",
        data: {}
      })
        .then(res => {
          this.registerVerifyCodeImg = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 免密登陆获取图片验证码
    getRegisterVerifyCodeImg2: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/User/verify",
        dataType: "json",
        data: {}
      })
        .then(res => {
          this.registerVerifyCodeImg2 = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getMsgCodeFunc: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "home/user/checkCode",
        dataType: "json",
        data: {
          verify_code: this.user_verify_code2,
          username: this.otherAccount,
          act: "forget"
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 1) {
            this.sendMsgTomobile();
          } else {
            this.getRegisterVerifyCodeImg2();
            this.showMsg(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    sendMsgTomobile: function() {
      this.$http({
        method: "post",
        // url: this.sendMobileMsgWebUrl + "/index.php?m=Home&c=Api&a=send_validate_code&scene=1&type=mobile&mobile="+this.otherAccount,
        url:
          this.weburl +
          "/index.php?m=Home&c=Api&a=send_validate_code&scene=6&type=mobile&mobile=" +
          this.otherAccount,
        dataType: "json",
        data: {}
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 1) {
            this.isGetCodeShow = false;
            this.countDown();
            this.showMsg(res.data.msg);
          } else {
            this.showMsg(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    countDown: function() {
      this.stopWaiting = setInterval(() => {
        this.waitingTime -= 1;
      }, 1000);
    },
    otherLoginFunc: function() {
      if (!this.otherAccount) {
        this.showMsg("请输入账号");
        this.getRegisterVerifyCodeImg2();
        return false;
      }
      if (!this.regTel.test(this.otherAccount)) {
        this.showMsg("手机号格式不正确");
        this.getRegisterVerifyCodeImg2();
        return false;
      }
      if (!this.user_verify_code2) {
        this.showMsg("图片验证码不能为空");
        this.getRegisterVerifyCodeImg2();
        return false;
      }
      if (!this.msgCheckCode) {
        this.showMsg("短信验证码不能为空");
        this.getRegisterVerifyCodeImg2();
        return false;
      }
      // 发送数据
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "home/User/do_login",
        dataType: "json",
        data: {
          // username:this.generalAccount,
          // password:this.generalPassWord,
          // verify_code:this.user_verify_code
          message: "message",
          scene: 6,
          username: this.otherAccount,
          verify_code: this.user_verify_code2,
          mes_code: this.msgCheckCode
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 1) {
            Toast(res.data.msg);
            this.loginSuccess(res.data.result);
            clearInterval(this.stopWaiting);
          } else {
            Toast(res.data.msg);
            this.getRegisterVerifyCodeImg2();
          }
        })
        .catch(err => {
          Toast("网络错误，请稍后再试");
          console.log(err);
        });
    },
    loginSuccess(data) {
      var obj = {};
      obj.nickname = data.nickname;
      obj.mobile = data.mobile;
      obj.head_pic = data.head_pic;
      //存入
      // localStorage.obj =JSON.stringify(obj) ;
      localStorage.setItem("userInfo", JSON.stringify(obj));
      /*  var user = JSON.parse(localStorage.getItem("userInfo"));
                  console.log(user);*/
      this.$store.commit("set_userInformation", obj);
      this.$router.go(-1);
      // console.log(data)
      /*if (window.history.length <= 1){
                    this.$router.push('/');
                } else {
                    this.$router.back(-1);
                }*/
      /* if (typeof document.referrer == '') {
                     this.$router.push({path: `/`});
                 }else{
                     window.location=history.go(-1);
                 }*/
    },
    forgetPsd() {
      this.$router.push({ path: `/findPassword` });
    },
    showMsg(msg) {
      Toast({
        message: msg,
        duration: 1000
      });
    },
    getRegister() {
      this.$router.push({ path: `/register` });
    },
    inputBlur() {
      //获取焦点
      if (event.path[0].value == "") {
        return false;
      }
      const DOM = event.currentTarget.parentElement; // 获取当前节点
      var nextDOM = DOM.nextElementSibling.firstChild;
      const divDOM = document.querySelector(".input_verity_box");
      if (nextDOM == divDOM) {
        nextDOM = divDOM.firstChild;
      }
      nextDOM.focus();
    }
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
    /* userInformation: function () {
                 return this.$store.state.personal.userInformation;
             },*/
    // isLogin:function () {
    //     return this.$store.state.personal.isLogin;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/loginCommon.less";

.login {
  width: @width;
  @media (min-width: 410px) {
    min-height: 502px;
  }
  @media (max-width: 375px) {
    min-height: 432px;
  }
  @media (max-width: 360px) {
    min-height: 394px;
  }
  @media (max-width: 320px) {
    min-height: 318px;
  }
  .login_lists {
    width: @width;
    text-align: center;
    height: @height;
    li {
      height: @height;
      line-height: @height;
      .box-sizing;
      float: left;
      color: @word;
      width: 50%;
      font-size: @font + 0.1;
      .border-bottom;
      &.list_active {
        .border-bottom(3px; @brick_red);
        color: @brick_red;
      }
    }
  }

  #account_login {
    input {
      width: @width;
    }
  }
  @height: 55px;
}

.verify_code_img {
  width: 96.19px;
  height: 50px;
}
@media (min-width: 768px) and (orientation: portrait) {
  .login {
    width: 375px;
    margin: 47px auto;
    padding: -15px;
    box-shadow: 1px 1px 10px #ccc;
    border-radius: 10px;
  }
}
</style>
